// @flow

import React from 'react';
import styled, { css } from 'styled-components';
import ACFPromotionCarBlock from '../carBlock/promotionCarBlock.acf';
import { media } from '../../helpers';
import type { Theme } from '../../types';

const List = styled<any, Theme>('ul')`
  display: flex;
  flex-wrap: wrap;
  margin: 0;
  padding: 0;
  list-style: none;
`;

const ListItem = styled<any, Theme>('li')`
  box-sizing: border-box;
  display: inline-flex;
  width: 100%;
  padding: 1rem 0 2rem 0;
  > div {
    width: 100%;
  }
  ${media.md(css`
    &:nth-of-type(even) {
      padding: 1rem 0 2rem 1rem;
    }
    padding: 1rem 1rem 2rem 0;
    width: 50%;
  `)}
`;

type Props = {
  items: Array<Object>,
};

const Top10List = ({ items }: Props) => (
  <List>
    {items.map((item, nr) => (
      <ListItem key={item.pdb_id}>
        <ACFPromotionCarBlock
          nr={(nr + 1).toString()}
          pdbId={item.pdb_id}
          title={item.title}
          subtitle={item.subtitle}
          background={item.background}
        />
      </ListItem>
    ))}
  </List>
);

export default Top10List;
